import type { SVGProps } from "react";
export interface DividerIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function DividerIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: DividerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="m3.003 10.875.115.006a1.126 1.126 0 0 1 0 2.238l-.115.006h-.005a1.125 1.125 0 0 1 0-2.25zm4.499 0 .114.006a1.125 1.125 0 0 1 0 2.238l-.114.006h-.006a1.125 1.125 0 0 1 0-2.25zm4.499 0 .114.006a1.125 1.125 0 0 1 0 2.238l-.114.006h-.006a1.125 1.125 0 0 1 0-2.25zm4.498 0 .114.006a1.125 1.125 0 0 1 0 2.238l-.114.006h-.006a1.125 1.125 0 0 1 0-2.25zm4.499 0a1.125 1.125 0 0 1 0 2.25h-.006a1.126 1.126 0 0 1 0-2.25zM19.875 21v-.8c0-.578 0-.944-.023-1.221a2 2 0 0 0-.038-.277l-.034-.1a.9.9 0 0 0-.265-.309l-.117-.073c-.03-.015-.112-.05-.375-.072-.277-.023-.645-.023-1.224-.023H6.201c-.579 0-.946 0-1.223.023a2 2 0 0 0-.276.04l-.1.032a.9.9 0 0 0-.31.265l-.072.117c-.014.029-.05.113-.071.377-.023.277-.024.643-.024 1.221v.8a1.125 1.125 0 0 1-2.25 0v-.8c0-.541 0-1.015.03-1.405.034-.403.108-.815.311-1.214l.12-.215c.3-.49.731-.888 1.246-1.15l.3-.13a3.6 3.6 0 0 1 .913-.18c.39-.033.864-.032 1.406-.032h11.598c.542 0 1.017 0 1.407.031.403.033.814.108 1.213.31l.215.12c.49.301.888.732 1.15 1.246l.13.302c.108.303.156.61.18.912.032.39.031.864.031 1.405v.8a1.125 1.125 0 0 1-2.25 0m-18-17.2V3a1.125 1.125 0 0 1 2.25 0v.8c0 .578.001.944.024 1.221.021.264.057.348.071.377l.072.117c.08.111.187.202.31.265l.1.032c.057.014.144.03.276.04.277.023.644.023 1.223.023h11.598c.58 0 .947 0 1.224-.023.263-.022.346-.057.375-.072l.117-.073a.9.9 0 0 0 .265-.31l.034-.099a2 2 0 0 0 .038-.277c.022-.277.023-.643.023-1.221V3a1.125 1.125 0 1 1 2.25 0v.8c0 .541.001 1.015-.03 1.405-.025.302-.073.61-.18.912l-.131.302a3.1 3.1 0 0 1-1.15 1.245l-.215.12c-.4.203-.81.278-1.213.31-.39.033-.865.031-1.407.031H6.201c-.542 0-1.016.002-1.406-.03a3.6 3.6 0 0 1-.913-.18l-.3-.13a3.1 3.1 0 0 1-1.245-1.15l-.12-.216c-.204-.399-.278-.811-.311-1.214-.032-.39-.03-.864-.03-1.405Z"
      />
    </svg>
  );
}
